<template>
  <div class="add-visit-record-container">
    <div class="page-header">
      <h2>新增回访记录</h2>
    </div>
    
    <el-card>
      <visit-record-form />
    </el-card>
  </div>
</template>

<script>
import VisitRecordForm from '../components/VisitRecordForm'

export default {
  name: 'AddVisitRecord',
  components: {
    VisitRecordForm
  }
}
</script>

<style scoped>
.add-visit-record-container {
  width: 100%;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #333;
}
</style>